export default {"src":"/_next/static/media/premierepro.f608c54b.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};